// Login Module
angular.module('app').controller('loginPageController', ['$scope', '$location', '$log', '$window', function ($scope, $location, $log, $window) {
	///////////////////////////////////////////////////////////////////////////
	// Members
    ///////////////////////////////////////////////////////////////////////////	
	$scope.message = '';	
	$scope.showErrorMessage = false;
	$scope.returnUrl = $location.search().returnUrl;
	$scope.targetPage = typeof($location.search().pg) == 'undefined' ? 'home.asp' : $location.search().pg;
	$scope.userEmail = $location.search().email;
	$scope.pageHeader = "Please log in to continue.";	
	$scope.referenceNumber = null;
	$scope.currentYear = new Date().getFullYear();
	$scope.errorType = $location.search().et;

	///////////////////////////////////////////////////////////////////////////
	// Functions
	///////////////////////////////////////////////////////////////////////////
	
	/**
	 * Watch for changes in the Assent Context Key
	 */
	$scope.$watch(function () {
		return $window.sessionStorage.getItem('assentContextKey')
	}, function (value) {
		$scope.referenceNumber = value;
	});

	/**
	 * Closes and resets error message
	 *
	 * @function
	 */
	$scope.closeErrorMessage = function() {
		// hide the message
		$scope.showErrorMessage = false;

		// set the message to empty string
		$scope.message = '';
	};

	
	/**
	 * Sets and displays error message
	 *
	 * @function
	 * @param { string } msg - The message to display
	 */
	$scope.setErrorMessage = function(msg) {
		// set the message 
		$scope.message = '<div>' + msg + '</div>';

		// show the message
		$scope.showErrorMessage = true;		
	};
}]);